<project-details-breadcrumb-header *ngIf="project != null"
  [project]="project"
  [title]="'PREVIEW & NOTES'"
  [breadcrumbs]="breadcrumbs"
></project-details-breadcrumb-header>
<div class="loader" [hidden]="status != STATUS_LOADING">
  <div class="dimmed ">
      <div class="dimmed_title long"></div>
  </div>
</div>

  <!-- ATTACHMENTS -->
  <div *ngIf="status == STATUS_DONE" class="project-details-file-preview">
    <core-files-list-item
        [file]="file"
        [menu]="menu"
        (menuClick)="onMenuClick($event)"
        (iconDownloadClick)="onActionDownloadClick($event)"
    ></core-files-list-item>
    <article>        
        <core-pdf-annotations-viewer
            [file]="file"
            [annotationsAllowed]="canCreateNotes"
            [urlAnnotationsPrefix]="notesUrlPrefix"
            [user]="user"
            (saved)="onNotesSaved($event)"
            (refreshSignaturesNeeded)="onRefreshSignaturesNeeded($event)"
        >
        </core-pdf-annotations-viewer>
    </article>
  </div >
